export default __webpack_public_path__ + "static/media/cover3.c0c71149.jpg";